import {UiIllustrations} from '../components/ui-illustrations';
import WistiaModal from '../modules/wistia-modal';
import '../application';

(function() {
  new UiIllustrations();
  document.querySelectorAll('.js-wistia-modal').forEach(($el) => new WistiaModal($el));
})();
